<template>
    <div class="dropdown">
        <v-select dir="rtl" label="title" v-model="stateValue" placeholder="شهر/شهرستان" :filterable="false" :options="StateOptions" @search="onSearchState" :reduce="p => p.stateId" @update:modelValue="handleInput">
            <template slot="no-options">
                جستجو...
            </template>
            <template slot="option">
                <div class="d-center">
                    {{ option.parentTitle }} - {{option.title}}
                </div>
            </template>
        </v-select>

    </div>
</template>

<script>
    import 'vue-select/dist/vue-select.css';
    export default {
        emits: ["update:modelValue"],
        props: ['value','firstValue','firstValueText'],
        data() {
            return {
                StateSearchText: this.firstValueText,
                stateValue: this.firstValue,
            };
        },
        computed: {
            StateOptions() {
                return this.$store.getters.GetStateList;
            }
        },
        methods: {
            handleInput(val) {
                
                this.$emit('update:modelValue', val)
            },
            onSearchState(search, loading) {
              
                    loading(true);
                    this.StateSearchText = search;
                    this.searchState(search);
                    loading(false);
                
            },
            searchState() {
                this.$store.dispatch("GetStateListFromServer", {
                    text: this.StateSearchText
                });
            }
        },
        created() {
            this.searchState();
            console.log(this.firstValue);
            console.log(this.firstValueText);
        },


    };
</script>